export const SUPPLIER_API = {
  user: '/api/user',
  logout: '/api/auth/logout',
  loginAsAdmin: '/api/login-as-admin',
  shopifyReauthStatus: '/api/shopify-reauth-status',
  shopifyReauthUrl: '/api/shopify-reauth-url',
  validateStoreUrl: '/api/validate-store-url',
  importProductsStatus: '/api/imports/shopify/products/status',
}
